/**
 * 西班牙语（es）
 */

import esLocale from 'element-ui/lib/locale/lang/es'
import publish from './publish/es'
import personal from './personal/es'
import order from './order/es'
import customProduct from './customProduct/es'
import index from './index/es'
import message from './message/es'

import billing from './billing/es'
import commodity from './commodity/es'
import home from './home/es'
import components from './components/es'

import personalCenter from './personal-center/es'

export default {
  ...esLocale,
  currency: {
    product: 'Productos',
    inStock: 'Inventario',
    myProduct: 'Mi producto',
    listings: 'Lista',
    myDesign: 'Mi diseño',
    wishList: 'Lista de deseos',
    allOrder: 'Todo orden',
    store: 'Tienda',
    personalCenter: 'Centro personal',
    payment: 'Pago',
    coupons: 'Cupones',
    address: 'Dirección',
    accountSettings: 'Configuración de la cuenta',
    logOut: 'Desconexión',
    cancel: 'Cancelar',
    submit: 'Submit',
    selectAll: 'Selección completa',
    confirmOrder: 'Confirmar orden',
    back: 'Vuelve aquí.',
    customProduct: 'Productos personalizados',
    home: 'Hogar',
    newIn: 'Recién llegado',
    deleteTip: '¿Está seguro de que desea eliminar el producto seleccionado?',
    delete: 'Táchar',
    customOrders: 'Pedidos personalizados',
    billingStatement: 'Estado de cuenta',
    RefundingOrder: 'Orden de reembolso',
    sortBy: 'Ordenar por',
    newest: 'El mas nuevo',
    highestInventory: 'Inventario más alto',
    highestSales: 'Ventas más altas',
    highestPrice: 'Precio más alto',
    lowestPrice: 'El precio más bajo'
  },
  // 语言
  lang: {
    english: 'Inglés',
    chinese: 'Chino',
    spanish: 'Español',
    japanese: 'Japonés',
    portuguese: 'Portugués',
    french: 'Francés',
    russian: 'Ruso',
    arabic: 'árabe',
    german: 'Alemán',
    italian: 'Italiano',
    vietnam: 'Viet Nam',
    turkey: 'Turquía',
    korean: 'Coreano',
    thai: 'Tailandés',
    dutch: 'Holandés',
    hebrew: 'Hebreo',
    indonesian: 'Indonesio'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {
    category: 'categoría',
    search: 'buscar',
    searchingFor: 'Separar varias búsquedas con comas o espacios',
    shippingFrom: 'Envío desde',
    supplierRank: 'Nivel de proveedor',
    supplierRankA: 'Proveedor de nivel a: el inventario total de cada spu supera los 300, y cada SKU suele superar los 100.',
    supplierRankB: 'Proveedor de nivel b: el inventario total de cada spu supera los 150, y cada SKU suele superar los 50.',
    supplierRankC: 'Proveedor de nivel c: el inventario total de cada spu es inferior a 100, y cada SKU suele estar entre 10 y 50.',
    fabric: 'Tela',
    price: 'Precio',
    inventory: 'Inventario',
    newest: 'Último',
    sales: 'Ventas',
    min: 'Minutos',
    max: 'Valor máximo',
    recentSearches: 'Búsqueda reciente',
    hotSearches: 'Búsqueda caliente'
  },
  // 商品详情页
  productDetail: {
    product: 'Productos',
    detail: 'Detalles',
    itemNo: 'Número de proyecto',
    processingTime: 'Tiempo de procesamiento',
    shippingCost: 'Flete',
    paymentMethod: 'Método de pago',
    sizeGuide: 'Tabla de tamaño',
    color: 'Color',
    size: 'Tamaño',
    viewAllVariants: 'Ver todas las variantes',
    allVariants: 'Todas las variantes',
    shipFrom: 'De',
    addToCart: 'Añadir al carrito de la compra',
    listToStore: 'Lista a almacenar',
    addToWishList: 'Añadir lista de deseos',
    description: 'Descripción',
    return: 'Return',
    refundPolicy: 'Política de reembolso',
    shipping: 'ShTransporte marítimoipping',
    image: 'Imagen',
    action: 'Acción',
    // 选项卡/shipping
    packingSize: 'Tamaño del envase',
    packingWeight: 'Peso del envase',
    shippingFrom: 'De',
    shippingTo: 'Transporte a',
    qty: 'Cantidad',
    maximum: 'Inventario máximo:',
    shippingMethod: 'Modo de transporte',
    estimatedDeliveryTime: 'Tiempo estimado de entrega',
    sizeChart: 'Tabla de tamaño',
    deliveryTime: 'Tiempo de entrega',
    outOfStockTips: '¡Lo siento, está fuera de stock!',
    pleaseSelected: 'Por favor, elija',
    customerReviews: 'Comentarios de los clientes',
    writeAReview: 'Escribir un comentario'
  },
  // 购物车
  shoppingCart: {
    shoppingCart: 'Carrito de compras',
    topTip: 'Seleccione los productos en el mismo almacén para hacer el pedido.',
    selectAll: 'Seleccionar todo'
  },
  // 确认订单
  confirmOrder: {
    shippingAddress: 'Dirección de entrega',
    addNewAddress: 'Añadir nueva dirección',
    selectAnotherAddress: 'Elija otra dirección',
    editTheAddress: 'Editar dirección',
    remark: 'Comentario',
    unitPrice: 'Precio unitario',
    totalPayable: 'Total pagadero',
    itemSubtotal: 'Subtotal del proyecto',
    subtotal: 'Subtotal',
    shippingSubtotal: 'Subtotal de transporte marítimo',
    promotion: 'Promoción',
    grandTotal: 'Total',
    creditCard: 'Tarjeta de crédito',
    balance: 'Equilibrio',
    payNow: 'Pago ahora',
    commonProblem: 'Preguntas frecuentes',
    emailVerification: 'Verificación por correo electrónico',
    verificationTitle: 'Código de autenticación enviado a su correo electrónico',
    verification: 'Verificación',
    seconds: 'Segundos',
    laterGetPasswordAgain: 'Obtener la contraseña más tarde',
    sendAgain: 'Enviar de nuevo'
  },
  // 账号设置弹窗
  setting: {
    setting: 'Antecedentes',
    fullName: 'Nombre completo',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    notVerified: 'No validado',
    change: 'Cambio',
    codeSend: 'Código de autenticación enviado a su correo electrónico',
    update: 'Actualizar',
    updateName: 'Actualizar nombre completo',
    UpdateEmail: 'Actualizar correo electrónico',
    UpdatePhone: 'Actualizar teléfono móvil',
    Tips1: 'Nosotras hemos enviado código a',
    Tips2: 'Longitud de la contraseña de 8 a 20 caracteres y al menos una letra mayúscula, una letra minúscula y un número.',
    fullNamePlaceholder: 'por favor ingrese el nombre completo',
    emailPlaceholder: 'por favor ingrese la dirección de correo electrónico',
    phonePlaceholder: 'por favor introduce el teléfono móvil',
    verificationCodePlaceholder: 'por favor ingrese el código de verificación',
    passwordPlaceholder: 'Por favor, ingrese contraseña'
  },
  // 张丰
  ...personal,

  // 孙泽严
  ...publish,
  ...order,
  ...customProduct,

  ...index,
  ...message,

  ...billing,
  ...commodity,
  ...home,
  ...personalCenter,
  ...components
}
